export const isExpiryDatePassed = (exp: number): boolean => {
  const now = (new Date().getTime()) / 1000;
  return exp < now;
};